import ReportsPage from './components/ReportsPage';

export default ReportsPage;
